<form [formGroup]="form" class="transparent">
  <div class="row">
    @if (!hideTypeField) {
      <div class="col-4">
        <mat-form-field>
          <mat-label>Current address</mat-label>
          <mat-select formControlName="type">
            <mat-option [value]="addressTypes.STREET">Street</mat-option>
            <mat-option [value]="addressTypes.POSTAL">Postal</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    }

    <!-- Search autocomplete -->
    <div [class]="hideTypeField ? 'col-12' : 'col-8'">
      <mat-form-field [hideRequiredMarker]="hideRequiredMarker">
        <mat-label>{{ label }}</mat-label>

        <input matInput
          [matAutocomplete]="autocomplete"
          [errorStateMatcher]="errorStateMatcher"
          formControlName="searchQuery"
          [placeholder]="placeholder"
          (blur)="onTouched()"/>

          <div matSuffix>
            <ng-container [appPreloader]="[endpoints.PROPERTIES_SUGGESTIONS_GET, endpoints.CORELOGIC_TOKEN_GET]"
              [preloaderType]="preloaderTypes.ICON"
              [preloaderSize]="20">
            </ng-container>
          </div>

          <mat-autocomplete #autocomplete="matAutocomplete"
            (optionSelected)="form.onSelectSuggestion($event.option.value)"
            [displayWith]="displaySuggestionFn">
            @if ((suggestions$ | async); as suggestions) {
              @for (suggestion of suggestions; track suggestion) {
                <mat-option [value]="suggestion">
                  {{suggestion.suggestion}}
                </mat-option>
              }
              <mat-option>
                Add manually
              </mat-option>
            }
          </mat-autocomplete>

          <mat-error>
            @if (form.get('searchQuery').invalid) {
              <app-validation-error
                [errors]="form.get('searchQuery').errors">
              </app-validation-error>
            }
            @if (form.get('corelogicRefId').invalid && !form.get('searchQuery').invalid) {
              <app-validation-error
                [errors]="form.get('corelogicRefId').errors">
              </app-validation-error>
            }
            @if (form.hasError('address')) {
              <div>{{form.errors?.address}}</div>
            }
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Manual fields -->
      @if (form.isManual) {
        <!-- Unit number -->
        <div class="col-4">
          <mat-form-field>
            <mat-label>Unit No.</mat-label>
            <input matInput formControlName="unitNumber" type="number" min="0" placeholder="Enter unit number">
          </mat-form-field>
        </div>
        <!-- Address -->
        <div class="col-4">
          <mat-form-field>
            <mat-label>Street No.</mat-label>
            <input matInput formControlName="streetNumber" placeholder="Enter street number">
            <mat-error>
              <app-validation-error [errors]="form.get('streetNumber').errors"></app-validation-error>
              <!-- @TODO Alex/Mikhail/Artem (TT-2471): implement validators with built-in messages -->
              @if (form.get('streetNumber').hasError('pattern')) {
                Spaces are not allowed
              }
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-4">
          <mat-form-field>
            <mat-label>Address</mat-label>
            <input matInput formControlName="street" placeholder="Enter street name">
            <mat-error>
              <app-validation-error [errors]="form.get('street').errors"></app-validation-error>
            </mat-error>
          </mat-form-field>
        </div>
        <!-- City -->
        <div class="col-4">
          <mat-form-field>
            <mat-label>Suburb</mat-label>
            <input matInput formControlName="city" placeholder="Enter locality name">
            <mat-error>
              <app-validation-error [errors]="form.get('city').errors"></app-validation-error>
            </mat-error>
          </mat-form-field>
        </div>
        <!-- State -->
        <div class="col-4">
          <mat-form-field>
            <mat-label>State</mat-label>
            @if (form.isAustraliaSelected()) {
              <mat-select formControlName="state" placeholder="Select state">
                @for (state of (states | keyvalue); track state) {
                  <mat-option [value]="state.key">{{state.value}}</mat-option>
                }
              </mat-select>
            } @else {
              <input matInput formControlName="state" placeholder="Enter state">
            }
            <mat-error>
              <app-validation-error [errors]="form.get('state').errors"></app-validation-error>
            </mat-error>
          </mat-form-field>
        </div>
        <!-- Postal code -->
        <div class="col-4">
          <mat-form-field>
            <mat-label>Postal code</mat-label>
            <input matInput formControlName="postcode" placeholder="Postal Code">
            <mat-error>
              <app-validation-error [errors]="form.get('postcode').errors"></app-validation-error>
            </mat-error>
          </mat-form-field>
        </div>
        <!-- Country -->
        @if (!hideCountryField) {
          <div class="col-4">
            <app-country-autocomplete formControlName="country"></app-country-autocomplete>
          </div>
        }
      }
    </div>
  </form>
